import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import { useJsApiLoader } from '@react-google-maps/api';

import Navbar from './Componentes/Navbar';
import Footer from './Componentes/Footer';
import Home from './Pages/Home';
import PropertySearchPage from './Componentes/PropertySearchPage';
import AdminDashboard from './Pages/AdminDashboard';
import PropertyDetails from './Pages/PropertyDetails';
import Nosotros from './Pages/QuienesSomos';
import FormContacto from './Pages/Form-Contacto';
import WhatsAppButton from './Componentes/Botton-Whatsapp';
import LoginPage from './Pages/LoginPage';
import UnavailableProperties from './Pages/UnavailableProperties';
import ForgotPassword from './Componentes/ForgotPassword';
import ResetPassword from './Componentes/ResetPassword';

const libraries = ['places'];

function Cancemi() {

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });
  
  const [properties, setProperties] = useState([]);
  const [filterType, setFilterType] = useState('');
  const [loadingProperties, setLoadingProperties] = useState(true); 

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get('https://backend-admin-nine.vercel.app/api/propiedades');
        setProperties(response.data);
      } catch (error) {
        console.error('Error al obtener propiedades:', error);
      } finally {
        setLoadingProperties(false); 
      }
    };

    fetchProperties();
  }, []);

  const handleFilterChange = (filterType) => {
    setFilterType(filterType);
  };

  const filteredProperties = properties.filter((property) => {
    if (!property.disponible) {
      return false;
    }

    if (filterType === 'venta') {
      return property.estado?.toLowerCase() === 'venta';
    }
    if (filterType === 'alquiler') {
      return property.estado?.toLowerCase() === 'alquiler';
    }
    if (filterType === 'emprendimiento') {
      return property.estado?.toLowerCase() === 'emprendimiento';
    }
    return true; 
  });

  const isAdminLoggedIn = localStorage.getItem('token');

  const shouldShowWhatsAppButton = !isAdminLoggedIn && (
    window.location.pathname === '/' ||
    window.location.pathname.startsWith('/alquiler') ||
    window.location.pathname.startsWith('/venta') ||
    window.location.pathname.startsWith('/emprendimiento') ||
    window.location.pathname.startsWith('/quienes_somos') ||
    window.location.pathname.startsWith('/contacto')
  );

  if (loadingProperties) {
    return <div>Cargando propiedades...</div>; 
  }

  return (
    <Router>
      <div className="App">
        <Navbar onFilterChange={handleFilterChange} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/alquiler" element={<PropertySearchPage filterType="alquiler" properties={filteredProperties} />} />
          <Route path="/venta" element={<PropertySearchPage filterType="venta" properties={filteredProperties} />} />
          <Route path="/emprendimiento" element={<PropertySearchPage filterType="emprendimiento" properties={filteredProperties} />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/contacto" element={<FormContacto />} />
          <Route path="/no-disponible" element={<UnavailableProperties />} />
          <Route path="/admin" element={isAdminLoggedIn ? <AdminDashboard /> : <Navigate to="/login" />} />
          <Route path="/Pages/PropertyDetails/:id" element={<PropertyDetails />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset/:token" element={<ResetPassword />} />
        </Routes>

        <Footer onFilterChange={handleFilterChange} />
        {shouldShowWhatsAppButton && <WhatsAppButton />}
      </div>
    </Router>
  );
}

export default Cancemi;
